import { BmHttp } from "../utils/Global";

export const createPDFlaboratorio = async (id) => {
    try {
        const response = await BmHttp().get(`genera-pdf-laboratorio/${id}`, { responseType: 'blob' });

        if (response.status === 200) {
            const link = document.createElement('a');
            const blob = response.data;
            const objectURL = URL.createObjectURL(blob);
            link.href = objectURL;
            link.download = 'HCU_10.pdf';
            //link.download =`HCU_010-${nombrePaciente}.pdf`;

            link.click();
            return { success: true };
        } else {
            return { success: false };
        }
    } catch (error) {
        console.error('Error al generar el ZIP:', error);

        return error;
        // return { success: false };
    }
};

export const createPDFpermisos = async (id) => {
    try {
        const response = await BmHttp().get(`genera-pdf-certificado-permiso/${id}`, { responseType: 'blob' });
        
        if (response.status === 200) {
            const link = document.createElement('a');
            const blob = response.data;
            const objectURL = URL.createObjectURL(blob);
            link.href = objectURL;
            link.download = 'Certificado_Permiso.pdf';
            //link.download =`HCU_012-${nombrePaciente}.pdf`;
            link.click();
            return { success: true };
        } else {
            return { success: false };
        }
    } catch (error) {
        console.error('Error al generar el PDF:', error);
        return { success: false };
    }
};
export const createPDFpermisosAsistencia = async (id) => {
    try {
        const response = await BmHttp().get(`genera-pdf-certificado-permiso-asistencia/${id}`, { responseType: 'blob' });
        
        if (response.status === 200) {
            const link = document.createElement('a');
            const blob = response.data;
            const objectURL = URL.createObjectURL(blob);
            link.href = objectURL;
            link.download = 'Certificado_Asistencia.pdf';
            //link.download =`HCU_012-${nombrePaciente}.pdf`;
            link.click();
            return { success: true };
        } else {
            return { success: false };
        }
    } catch (error) {
        console.error('Error al generar el PDF:', error);
        return { success: false };
    }
};
export const createPDFInterconsulta = async (id) => {
    try {
        const response = await BmHttp().get(`genera-pdf-interconsulta/${id}`, { responseType: 'blob' });
        
        if (response.status === 200) {
            const link = document.createElement('a');
            const blob = response.data;
            const objectURL = URL.createObjectURL(blob);
            link.href = objectURL;
            link.download = 'HCU_INTERCONSULTA.pdf';
            //link.download =`HCU_012-${nombrePaciente}.pdf`;
            link.click();
            return { success: true };
        } else {
            return { success: false };
        }
    } catch (error) {
        console.error('Error al generar el PDF:', error);
        return { success: false };
    }
};
export const createPDFimagenExterna = async (id) => {
    try {
        const response = await BmHttp().get(`genera-pdf-imagenesExternas/${id}`, { responseType: 'blob' });
        
        if (response.status === 200) {
            const link = document.createElement('a');
            const blob = response.data;
            const objectURL = URL.createObjectURL(blob);
            link.href = objectURL;
            link.download = 'ORDEN_EXTERNA.pdf';
            //link.download =`HCU_012-${nombrePaciente}.pdf`;
            link.click();
            return { success: true };
        } else {
            return { success: false };
        }
    } catch (error) {
        console.error('Error al generar el PDF:', error);
        return { success: false };
    }
};
export const createPDFreceta = async (id,nombrePaciente) => {
    try {
        const response = await BmHttp().get(`genera-pdf-receta/${id}`, { responseType: 'blob' });
        
        if (response.status === 200) {
            const link = document.createElement('a');
            const blob = response.data;
            const objectURL = URL.createObjectURL(blob);
            link.href = objectURL;
            //link.download = 'receta.pdf';
            link.download = `RECETA-${nombrePaciente}.pdf`;
            link.click();
            return { success: true };
        } else {
            return { success: false };
        }
    } catch (error) {
        console.error('Error al generar el PDF:', error);
        return { success: false };
    }
};
export const createPDFCotizacionlaboratorio = async (id) => {
    try {
        const response = await BmHttp().get(`genera-pdf-laboratorio-cotizacion/${id}`, { responseType: 'blob' });
        
        if (response.status === 200) {
            const link = document.createElement('a');
            const blob = response.data;
            const objectURL = URL.createObjectURL(blob);
            link.href = objectURL;
            link.download = 'HCU_10.pdf';
            //link.download =`HCU_010-${nombrePaciente}.pdf`;

            link.click();
            return { success: true };
        } else {
            return { success: false };
        }
    } catch (error) {
        console.error('Error al generar el PDF:', error);
        return { success: false };
    }
};
